<div fxLayout="column" fxLayoutAlign="start start" class="bottom-sheet">
  @if (content.title) {
    <div class="bottom-sheet__title">{{content.title}}</div>
  }
  <mat-nav-list class="bottom-sheet__list list-item-row">
    @for (listItem of content.list; track listItem.value) {
      <button mat-list-item type="button" fxLayout="row"
        (click)="dismissSheet(listItem)"
        class="bottom-sheet__list-item-row-divider"
        [disabled] = "listItem.disabled"
        [ngClass]="{'bottom-sheet__selected-list-item' : content.selectedItem === listItem.value}"
       
       
       
       >
        @if (listItem.image) {
          <div matListItemAvatar>
            <img  alt="Reward Image" class="bottom-sheet__reward-image" src="{{listItem.image}}"/>
          </div>
        }
        <div matListItemTitle class="bottom-sheet__list-item">{{listItem.name}}</div>
      </button>
    }
    @if (content.isCancel) {
      <button mat-list-item type="button" fxLayout="row"
        fxLayoutAlign="start center"
        (click)="bottomSheetRef.dismiss()"
       
       
       
       >
        <mat-icon class="bottom-sheet__cancel-icon">close</mat-icon>
        <span class="bottom-sheet__cancel-list-item">
          Cancel
        </span>
      </button>
    }
  </mat-nav-list>
</div>
